import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { routeConstant } from '@flitpay-internal/resources';
import { CommonFooterComponent, footerMenueItems } from '@flitpay-internal/web-footer';
import { CommonHeadersComponent } from '@flitpay-internal/web-header';
import { PusherChannelKey, PusherService, ConnectionType, PusherActivityDebugComponent } from '@flitpay-internal/graphql';
import type { PusherConnectionType } from '@flitpay-internal/graphql';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../environments/environment';
import { AppUpdateService } from './resources/_services/app-update.service';
import { ClarityService } from './resources/_services/clarity.service';
import { AskUpdateComponent } from './resources/_modals/ask-update/ask-update.component';

@Component({
	selector: 'fpl-root',
	imports: [RouterOutlet, CommonFooterComponent, CommonHeadersComponent, PusherActivityDebugComponent, AskUpdateComponent],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
	title = 'flitpay-landing';
	public baseUrl: string = environment?.baseUrl ?? '';
	public exchangeRoute: string = routeConstant?.spotPageRoute ?? '';
	public qbsRoute: string = (routeConstant?.qbsBuyRoute ?? '') + 'btc/inr';
	public menusBaseUrl: string = environment?.s3StaticBucket ?? '';
	public isDebug = signal(environment?.production ? false : true);

	constructor(
		private pusherService: PusherService,
		private appUpdateService: AppUpdateService,
		_clarityService: ClarityService,
		@Inject(PLATFORM_ID) private platformId: Object
	) {
		this.appUpdateService.checkForUpdates();
	}

	ngOnInit(): void {
		//Called after the constructor, initializing input properties, and the first call to ngOnChanges.
		if (isPlatformBrowser(this.platformId)) {
			this.pusherService.initializePusher(false);

			this.pusherService.pusherConnectionStateAnnounced$.subscribe((state: PusherConnectionType) => {
				if (state?.status === ConnectionType.connected) {
					this.pusherService.subscribeToChannel(PusherChannelKey.GLOBAL_DATA);
				}
			});
		}
	}

	ngOnDestroy(): void {
		//Called once, before the instance is destroyed.
		//Add 'implements OnDestroy' to the class.
		this.pusherService.stopPusher();
	}
}
